import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import { Props } from './Deviousness';

type StateProps = Pick<
  Props,
  | 'moduleVersion'
  | 'dateAwarded'
  | 'description'
  >;
type OwnProps = Omit<Props, keyof (StateProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { dateAwarded, description } = getModuleData(state, ownProps.moduleId);
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  return {
    moduleVersion,
    dateAwarded,
    description,
  };
};

export default connect(mapStateToProps);
